export const A_ELEMENT_TAG_REST_ATTRS = {
  target: "_blank",
  rel: "noopener",
}

export const STORAGE_KEY = {
  INDUSTRY: "industry",
  BLOG_TAG: "blog-tag",
  BLOG_CATEGORY: "blog-category",
  PRACTICE: "practice-tags",
  SOLUTION: "solution-category",
  SCENE: "scene",
}

export enum RETURN_BUTTON_KEY {
  CASE,
  INSIGHT,
  JOINT_SOLUTION,
  SOLUTION,
  BEST_PRACTICE,
  BLOG,
}
